export default __webpack_public_path__ + "static/media/avatar-4.b23e41d9.jpg";